import { GOOGLE_ROADMAP } from '@carto/react-basemaps';
import { API_VERSIONS } from '@deck.gl/carto';
import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  viewState: {
    latitude: 37.1704606,
    longitude: -119.4845866,
    zoom: 5.7,
    pitch: 0,
    bearing: 0,
    dragRotate: false,
  },
  basemap: GOOGLE_ROADMAP,
  credentials: {
    apiVersion: API_VERSIONS.V3,
    apiBaseUrl: 'https://gcp-us-east1.api.carto.com',
    accessToken: process.env.REACT_APP_CARTO_ACCESS_TOKEN,
  },
  googleApiKey: process.env.REACT_APP_GOOGLE_API_KEY,
  googleMapId: process.env.REACT_APP_GOOGLE_MAP_ID,
  crosshairCursorActive: false, 
};
